import { NavLink } from "react-router-dom";
import "./NavBar.css";

function NavBar({ onClickLink }) {
  const handleClick = () => {
    if (onClickLink) onClickLink();
  };

  return (
    <div className="nav-links">
      <NavLink
        to="/home"
        className={({ isActive }) => (isActive ? "active" : "")}
        onClick={handleClick}
      >
        Startseite
      </NavLink>
      <NavLink
        to="/services"
        className={({ isActive }) => (isActive ? "active" : "")}
        onClick={handleClick}
      >
        Leistungen
      </NavLink>
      <NavLink
        to="/about-us"
        className={({ isActive }) => (isActive ? "active" : "")}
        onClick={handleClick}
      >
        Über Uns
      </NavLink>
      <NavLink
        to="/contact"
        className={({ isActive }) => (isActive ? "active" : "")}
        onClick={handleClick}
      >
        Kontakt
      </NavLink>
    </div>
  );
}

export default NavBar;
